// extracted by mini-css-extract-plugin
export default {"workflowDetail":"detail_workflowDetail__NjTKc","title":"detail_title__MjUSJ","item":"detail_item__rn3nh","inputItem":"detail_inputItem__4DpCd","taskItem":"detail_taskItem__O4IEY"};